
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { TranslateResult } from "vue-i18n";
import AppHumanFilterListEdit from "@/components/models/HumanFilterListEdit.vue";
import { BrowseService } from "@/services/browse-service";
import { Model, getModel } from "@/utils/models/model";
import { Browse } from "@/models/browse";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import { DashboardChartDataWithBanks } from "@/utils/dashboard/dashboard-chart-data-with-banks";


export default Vue.extend({
	data(){
		return {
			data: new DashboardChartDataWithBanks(),
			browse: undefined as undefined | Browse,
			bankBrowse: undefined as undefined | Browse
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		model():Model | undefined{
			if (!this.browse) return undefined;
			return getModel(this.browse.Table);
		},
		bankModel():Model | undefined {
			if (!this.bankBrowse) return undefined;
			return getModel(this.bankBrowse.Table);
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data) {
					this.data = new DashboardChartDataWithBanks();
					return;
				}
				this.data = new DashboardChartDataWithBanks(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
	},
	async created() {
		this.browse = BrowseService.browses.find(b=>b.ID == 6);
		this.bankBrowse = BrowseService.browses.find(b=>b.ID == 8);
	},
	components: {
		AppHumanFilterListEdit,
		AppSelectBookYear
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
